import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac9de38c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkbox" }

import { reactive } from "vue";
import CustomModal from "../generics/CustomModal.vue";
import TermsAndConditions from "@/components/blocks/TermsAndConditions.vue";
import { useBookingStore } from "@/store/bookingStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'TermsAndConditionsCheckbox',
  setup(__props) {

const bookingStore = useBookingStore();

const state = reactive({
	showModal: false,
});

function handleLinkClick() {
	state.showModal = true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        id: "termsAndCond",
        name: "termsAndCond",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bookingStore).order.acceptTermsAndConditions) = $event))
      }, null, 512), [
        [_vModelCheckbox, _unref(bookingStore).order.acceptTermsAndConditions]
      ]),
      _createElementVNode("label", null, [
        _createTextVNode(" Jag har läst och godkänner webbplatsens "),
        _createElementVNode("a", {
          onClick: handleLinkClick,
          class: "termslink"
        }, "villkor")
      ])
    ]),
    _createVNode(CustomModal, {
      show: state.showModal,
      fullHeight: false,
      onOnClose: _cache[1] || (_cache[1] = ($event: any) => (state.showModal = false))
    }, {
      header: _withCtx(() => [
        _createTextVNode(" Allmänna villkor ")
      ]),
      body: _withCtx(() => [
        _createVNode(TermsAndConditions)
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})